<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  background-color: #EFE7E0;
  font-family: 'Nunito', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #2B2420;
  -webkit-font-smoothing: antialiased;
}
</style>
